import React, { useState, useEffect } from "react";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

interface ImportNameInputProps {
  onNameSubmit: (name: string) => void;
  fileName?: string;
}

const ImportNameInput: React.FC<ImportNameInputProps> = ({ onNameSubmit, fileName }) => {
  const [importName, setImportName] = useState("");
  
  useEffect(() => {
    if (!importName && fileName) {
      // Extraire le nom du fichier sans l'extension
      const baseName = fileName.replace(/\.[^/.]+$/, "");
      setImportName(`Import ${baseName}`);
      onNameSubmit(`Import ${baseName}`);
    }
  }, [fileName, importName, onNameSubmit]);
  
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setImportName(e.target.value);
    onNameSubmit(e.target.value);
  };
  
  return (
    <div className="space-y-2">
      <Label htmlFor="import-name">Nom de l&apos;import (optionnel)</Label>
      <Input
        id="import-name"
        placeholder="Import du 04-04-2025"
        value={importName}
        onChange={handleInputChange}
        className="max-w-md focus:ring-[#1b2445] focus:border-[#1b2445]"
      />
      <p className="text-sm text-gray-500">
        {!importName && "Un nom sera généré automatiquement si vous n'en spécifiez pas"}
      </p>
    </div>
  );
};

export default ImportNameInput;
